import DOMPurify from "dompurify";

/**
 * Sanitizes user input to prevent XSS attacks
 * @param dirty - The input string to sanitize
 * @returns Clean string safe for HTML
 */
export const sanitizeInput = (dirty: string): string => {
  if (!dirty || typeof dirty !== "string") {
    return "";
  }

  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: [], // No HTML tags allowed for user input
    ALLOWED_ATTR: [],
    KEEP_CONTENT: true,
  });
};

/**
 * Sanitizes user input while preserving safe HTML formatting
 * Used for rich text content like descriptions
 * @param dirty - The input string to sanitize
 * @returns Clean string with safe HTML tags
 */
export const sanitizeHtml = (dirty: string): string => {
  if (!dirty || typeof dirty !== "string") {
    return "";
  }

  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: ["b", "i", "strong", "em", "a", "p", "br", "ul", "ol", "li"],
    ALLOWED_ATTR: ["href", "title"],
    SAFE_FOR_TEMPLATES: true,
  });
};

/**
 * Escapes HTML special characters in text
 * @param text - The text to escape
 * @returns Escaped text safe for display
 */
export const escapeHtml = (text: string): string => {
  if (!text || typeof text !== "string") {
    return "";
  }

  const div = document.createElement("div");
  div.textContent = text;
  return div.innerHTML;
};

export default DOMPurify;
